import AlertInlineMessage from '@components/ui/AlertInlineMessage';
import Heading from '@components/ui/Heading';
import cn from 'classnames';
import { useTranslation } from 'next-i18next';

import styles from './ResetPasswordAlert.module.scss';

export interface ResetPasswordAlertProps {
  isModal?: boolean;
}

const ResetPasswordAlert = ({ isModal = false }: ResetPasswordAlertProps) => {
  const { t } = useTranslation('common');

  return (
    <AlertInlineMessage
      messageType="WARNING"
      classNames={cn(styles.resetPasswordAlert, { [styles.isModal]: isModal })}
    >
      <Heading semanticLevel="h3" styleLevel="6">
        {t('login.alert.heading')}
      </Heading>
      <p className={styles.resetPasswordAlertSubText}>
        {t('login.alert.text')}
      </p>
    </AlertInlineMessage>
  );
};

export default ResetPasswordAlert;
